import React, { useState } from 'react';
import {
  WavingHandOutlined,
  FactCheckOutlined,
  QuizOutlined,
  CalendarMonthOutlined,
  AutoStoriesOutlined,
  InsightsOutlined,
  ArrowBackOutlined,
  ArrowForwardOutlined,
  RocketLaunchOutlined
} from '../../icons';
import './Onboarding.css';

const SLIDES = [
  {
    icon: WavingHandOutlined,
    title: 'Bem-vindo ao Portal Preparate!',
    description:
      'Tudo o que você precisa para chegar preparado até a prova da Polícia Penal RS, em um só lugar. Vamos te mostrar rapidinho o que tem por aqui.',
    bullets: []
  },
  {
    icon: FactCheckOutlined,
    title: 'Simulados completos',
    description: 'Faça simulados cronometrados com questões de provas anteriores.',
    bullets: [
      'Escolha o formato: todas as questões juntas ou uma por vez',
      'Marque questões para revisão e elimine alternativas',
      'Imprima o simulado para responder no papel'
    ]
  },
  {
    icon: QuizOutlined,
    title: 'Questões por matéria',
    description: 'Pratique exatamente o que precisa, filtrando por matéria específica do edital.',
    bullets: [
      'Mesma escolha de formato: tudo junto ou uma por vez',
      'Carregue mais questões sempre que quiser',
      'Feedback na hora, com a explicação de cada resposta'
    ]
  },
  {
    icon: CalendarMonthOutlined,
    title: 'Plano de Estudos Personalizado',
    description:
      'Diga quantas horas e dias você tem disponíveis e receba um cronograma semanal automático.',
    bullets: [
      'Prioridade Alta, Média ou Baixa para cada matéria',
      'Calendário visual de Segunda a Domingo',
      'Gere de novo sempre que quiser ajustar'
    ]
  },
  {
    icon: AutoStoriesOutlined,
    title: 'Material de Estudo',
    description: 'Apostilas e leis secas em PDF para complementar seus estudos, prontas para baixar.',
    bullets: []
  },
  {
    icon: InsightsOutlined,
    title: 'Meu Desempenho',
    description: 'Acompanhe suas estatísticas de acerto por matéria e por simulado, e veja sua evolução.',
    bullets: []
  }
];

function Onboarding({ onClose }) {
  const [step, setStep] = useState(0);
  const isLast = step === SLIDES.length - 1;
  const slide = SLIDES[step];

  const goNext = () => {
    if (isLast) {
      onClose();
    } else {
      setStep((s) => s + 1);
    }
  };

  const goPrev = () => setStep((s) => Math.max(0, s - 1));

  return (
    <div className="onboarding-backdrop">
      <div className="onboarding-card">
        <button type="button" className="onboarding-skip" onClick={onClose}>
          Pular
        </button>

        <div className="onboarding-icon">
          <slide.icon style={{ fontSize: 48 }} />
        </div>
        <h2 className="onboarding-title">{slide.title}</h2>
        <p className="onboarding-description">{slide.description}</p>

        {slide.bullets.length > 0 && (
          <ul className="onboarding-bullets">
            {slide.bullets.map((bullet, index) => (
              <li key={index}>{bullet}</li>
            ))}
          </ul>
        )}

        <div className="onboarding-dots">
          {SLIDES.map((_, index) => (
            <span key={index} className={`onboarding-dot ${index === step ? 'active' : ''}`} />
          ))}
        </div>

        <div className="onboarding-actions">
          <button
            type="button"
            className="onboarding-prev"
            onClick={goPrev}
            disabled={step === 0}
          >
            <ArrowBackOutlined style={{ fontSize: 16, verticalAlign: 'middle', marginRight: 4 }} />
            Voltar
          </button>
          <button type="button" className="onboarding-next" onClick={goNext}>
            {isLast ? (
              <>
                Começar agora
                <RocketLaunchOutlined style={{ fontSize: 16, verticalAlign: 'middle', marginLeft: 4 }} />
              </>
            ) : (
              <>
                Próximo
                <ArrowForwardOutlined style={{ fontSize: 16, verticalAlign: 'middle', marginLeft: 4 }} />
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
}

export default Onboarding;
